import {
  Create,
  ListButton,
  minValue,
  NumberInput,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { ClientAppInput } from "@/modules/clientApps";
import { PaymentProviderInput } from "@/modules/paymentProviderModel";

import { BILLING_STRATEGY_CHOICES } from "./constants";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const TariffCreate = () => (
  <Create actions={<CreateActions />} redirect="list">
    <SimpleForm toolbar={<CreateToolbar />}>
      <PaymentProviderInput source="paymentProviderId" />
      <TextInput source="productId" label="Product Id" />
      <NumberInput source="price" validate={[minValue(0)]} />
      <TextInput source="publicKey" />
      <SelectInput
        source="billingStrategy"
        validate={required()}
        choices={BILLING_STRATEGY_CHOICES}
      />
      <ClientAppInput label="Client App" source="clientApp" optionValue="@id" />
    </SimpleForm>
  </Create>
);
